exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".states-services--7My0qQD-SK090IgNTsCUL {\n  margin: 0 0 0 5px;\n  text-transform: uppercase;\n}\n\n.states-services--1Rnx0EsHIHhxJbCnNVCkN1 {\n  font-size: .75rem;\n}\n\ndiv.states-services--1i9tHFN7t3E4dqsgCTwqdY {\n  font-size: .75rem;\n  margin-top: 15px;\n}\n\nbutton.states-services--3AChti86BeU_8lugN-7ZYD {\n  margin-top: 0;\n}\n", ""]);

// exports
exports.locals = {
	"editRulesLink": "states-services--7My0qQD-SK090IgNTsCUL",
	"editRulesLink": "states-services--7My0qQD-SK090IgNTsCUL",
	"formDescription": "states-services--1Rnx0EsHIHhxJbCnNVCkN1",
	"formDescription": "states-services--1Rnx0EsHIHhxJbCnNVCkN1",
	"formDisclaimer": "states-services--1i9tHFN7t3E4dqsgCTwqdY",
	"formDisclaimer": "states-services--1i9tHFN7t3E4dqsgCTwqdY",
	"formSubmitButton": "states-services--3AChti86BeU_8lugN-7ZYD",
	"formSubmitButton": "states-services--3AChti86BeU_8lugN-7ZYD"
};